import { RodzajProjektu } from './rodzajProjektu';

export class PobierzProjektyFiltr {
  wartoscSzukaj: string;
  aktywne: boolean;
  rodzajProjektu: RodzajProjektu;
}
